import React, { useState } from "react";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomNumberInput from "../../../../components/CustomNumberInput";
import Box from "../../../../components/Box";
import { Helpers } from "../../../../helpers/Helpers";
import { GetAmbarAgreementByIdResponseAmbarAgreementScale } from "../../../../models/response/ambarAgreement/GetAmbarAgreementByIdResponse";
import { storeAreYouSureModalCallback } from "../../../../redux/reducers/authSlice";
import { useDispatch } from "react-redux";

interface Props {
    scaleInformationRef: any
    ambarAgreementScales: GetAmbarAgreementByIdResponseAmbarAgreementScale[]
    setAmbarAgreementScales: React.Dispatch<React.SetStateAction<GetAmbarAgreementByIdResponseAmbarAgreementScale[]>>
}

const ScaleInformation = ({
    scaleInformationRef,
    ambarAgreementScales,
    setAmbarAgreementScales
}: Props) => {
    const dispatch = useDispatch();
    const [ambarAgreementScaleId, setAmbarAgreementScaleId] = useState<string | undefined>(undefined);
    const [isOpen, setIsOpen] = useState(false);
    const [unitPrice, setUnitPrice] = useState<string | undefined>(undefined);
    const [startPrice, setStartPrice] = useState<string | undefined>(undefined);
    const [interval, setInterval] = useState<string | undefined>(undefined);

    const saveItem = () => {
        if (Helpers.isEmpty(ambarAgreementScaleId)) {
            var o: GetAmbarAgreementByIdResponseAmbarAgreementScale = {
                ambarAgreementScaleId: Helpers.generateUUID(true),
                isSelected: false,
                interval: interval?.toString(),
                unitPrice: unitPrice?.toString(),
                startPrice: startPrice?.toString()
            }

            setAmbarAgreementScales([...ambarAgreementScales, o])
        }
        else {
            setAmbarAgreementScales(ambarAgreementScales.map(function (x) {
                if (x.ambarAgreementScaleId == ambarAgreementScaleId) {
                    x.isSelected = false;
                    x.interval = interval?.toString();
                    x.unitPrice = unitPrice?.toString();
                    x.startPrice = startPrice?.toString();
                }

                return x;
            }))
        }

        setAmbarAgreementScaleId('');
        setUnitPrice('');
        setStartPrice('');
        setInterval('');

        setIsOpen(false);
        scrollTo();
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setAmbarAgreementScaleId('');
        setUnitPrice('');
        setStartPrice('');
        setInterval('');

        setIsOpen(false);
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = ambarAgreementScales.filter(x => x.isSelected)[0];

        setAmbarAgreementScaleId(o.ambarAgreementScaleId);

        setUnitPrice(o.unitPrice);
        setStartPrice(o.startPrice);
        setInterval(o.interval);

        setIsOpen(true);
        scrollTo();
    }

    const selectAll = () => {
        var isAllSelected = ambarAgreementScales.length == ambarAgreementScales.filter(x => x.isSelected).length;

        setAmbarAgreementScales(ambarAgreementScales.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const deleteItems = async () => {
        setAmbarAgreementScales(ambarAgreementScales.filter(x => !x.isSelected));
    }

    const setItemSelected = (_id: string) => {
        setAmbarAgreementScales(ambarAgreementScales.map(function (x) {
            if (x.ambarAgreementScaleId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = scaleInformationRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    return (
        <div className='containerPart' ref={scaleInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Barem Bilgileri</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className="row">
                                    <div className="col-md-4">
                                        <CustomNumberInput allowNegative labelText="Başlangıç Fiyatı" isLabelRequired value={startPrice} setValue={setStartPrice} />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Birim Fiyat" isLabelRequired value={unitPrice} setValue={setUnitPrice} />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Aralık" isLabelRequired value={interval} setValue={setInterval} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} opacity={"1"} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={ambarAgreementScales.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={ambarAgreementScales.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>

                        <Box onClick={ambarAgreementScales.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={ambarAgreementScales.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={ambarAgreementScales.filter(x => x.isSelected).length > 0 && ambarAgreementScales.filter(x => x.isSelected).length == ambarAgreementScales.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Başlangıç Fiyatı</th>
                                            <th>Birim Fiyat</th>
                                            <th>Aralık</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            ambarAgreementScales.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            ambarAgreementScales.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={() => setItemSelected(item.ambarAgreementScaleId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{Helpers.correctPrice(item.startPrice, 2)}</td>
                                                    <td>{item.unitPrice}</td>
                                                    <td>{item.interval}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default ScaleInformation;